import React, {useState} from "react";
import {Col, Form} from "react-bootstrap";
import LockIcon from "assets/icons/lock-icon.png";

import {useForm} from "react-hook-form";

import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from "yup";

import {Link} from "react-router-dom";
import SingleInput from "./SingleInput";
import axios from "axiosConfig";
import {useDispatch} from "react-redux";
import {showLogin} from "actions/ui_control";

function SendResetPassword({
                             setView,
                             nextView,

                             setEmail,
                             ...props
                           }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Watch password input changes
  // Validation schema
  const schema = yup.object().shape({
    email: yup
      .string()
      .email("Please use a valid email.")
      .required("Please choose an email."),
  });
  const {
    register,
    handleSubmit,
    formState: {errors},
  } = useForm({
    defaultValues: {
      email: "",
    },
    mode: "onChange",
    // Define validation schema
    resolver: yupResolver(schema),
  });

  // Function to check if password requirements are passed

  const handleRequestChangingPassword = formState => {
    setLoading(true);
    const {email} = formState;
    axios
      .post("/api/auth/reset-password/", {email})
      .then(() => {
        setView(nextView);
        setEmail(email);
      })
      .catch(error => {
        setError(
          error.response.data.message.non_field_errors ||
          "We couldn't complete your request."
        );
        setTimeout(() => setError(null), 5000);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const dispatch = useDispatch();
  const showLoginFunc = () => {
    dispatch(showLogin());
  };
  return (
    <>
      {/* Header section */}
      <Col sm={12} className="modal-header px-2">
        <img src={LockIcon} alt="lock-icon"/>
        <h3 className="mt-4 mb-3">Forgot your password?</h3>
        <p className="mt-2 mb-0">
          Remember password? <Link onClick={showLoginFunc}>Log In</Link>
        </p>
      </Col>
      {/* Form section */}

      {/* First step */}
      <Form
        sm={12}
        noValidate
        onSubmit={handleSubmit(handleRequestChangingPassword)}
      >
        <SingleInput
          // label="Email"
          name={"email"}
          type="email"
          errors={errors}
          register={register}
          placeholder="Please enter your email."
        />
        <div className="form-group pt-2 pb-2">
          <button
            className="btn btn-primary btn-block btn-full"
            disabled={loading}
          >
            {loading && (
              <span className="spinner-border spinner-border-sm"></span>
            )}
            {loading ? "Sending Verification Link" : "Send Verification Link"}
          </button>
        </div>
        {error && (
          <div className="form-group mt-3">
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          </div>
        )}
      </Form>
    </>
  );
}

export default SendResetPassword;
